import { useRole } from '../hooks/useRole';
import React, { type ComponentType } from 'react';
import { Alert, AlertTitle, Typography } from '@mui/material';

interface AuthorizationGuardProps {
	Component: ComponentType<{
		backwardRoute?: string; // Optional backwardRoute type
	}>;
	everyoneAccess?: boolean;
	userAccess?: boolean;
	supplierAccess?: boolean;
	adminAccess?: boolean;
	backwardRoute?: string;
}

export default function AuthorizationGuard({
	Component,
	everyoneAccess = false,
	userAccess = false,
	supplierAccess = false,
	adminAccess = false,
	backwardRoute,
}: AuthorizationGuardProps) {
	const { isAdmin, isUser, isSupplier } = useRole();

	const denyView = (
		<Alert severity="error">
			<AlertTitle sx={{ typography: 'h6' }}>Error</AlertTitle>
			<Typography>You don't have sufficient permissions to access this page.</Typography>
		</Alert>
	);

	if (isAdmin || everyoneAccess) {
		return <Component {...{ backwardRoute }} />;
	}

	if (adminAccess) {
		return denyView;
	}

	if (userAccess) {
		return isUser ? <Component {...{ backwardRoute }} /> : denyView;
	}

	if (supplierAccess) {
		return isSupplier ? <Component {...{ backwardRoute }} /> : denyView;
	}

	return denyView; // Fallback for cases where none of the conditions match
}
